import type { LocateOrder } from '@thinkalpha/ui-types/contracts/locates/orders';
import type { LocateInjectRequest, LocateInjectResponse } from '@thinkalpha/ui-types/contracts/locates/platforms';
import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config';
import { InjectLocatesParamsSchema } from 'src/queries/locatesV2/injection';
import type { InjectLocatesParams } from 'src/queries/locatesV2/injection';
import { v4 as uuidv4 } from 'uuid';

const axios = createInstance({ baseURL: appConfig.locatesApi });

export async function injectLocates(params: InjectLocatesParams): Promise<LocateOrder[]> {
    const { accountId, receipts } = InjectLocatesParamsSchema.parse(params);
    const request = {
        receipts: receipts.map((receipt) => ({
            ...receipt,
            optimisticOrderId: receipt.optimisticOrderId ?? uuidv4(),
        })),
    } satisfies LocateInjectRequest;
    const { data } = await axios.post<LocateInjectResponse>(
        `/platforms/accounts/${encodeURIComponent(accountId)}/inject`,
        request,
    );
    return data.injections;
}
